import { TAB, TAB_REMOVE } from '../types'

export const tabReducer = (state = 'account', action) =>{
  const {type, payload} = action

  switch (type) {
    case TAB: {
      let {data} = payload
      return data
    }
    case TAB_REMOVE: {
      return {}
    }
    default: {
      return state
    }
  }
}
